import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { HeaderView } from '@merchant-backend/common-components'
import { Link } from 'react-router'
import store from './store'
import Table from './Table'
import { Button } from 'hljd'
import styles from './style.module.less'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    let {
      params: { id, positionId }
    } = props
    store.id = id
    store.positionId = positionId
    store.getPositionInfoApi(id, positionId)
  }
  render() {
    const { activity_position } = store
    return (
      <HeaderView
        header={[
          <Link to="/localMerchant/activityRegister">活动报名</Link>,
          '选择套餐'
        ]}
        title="选择套餐"
        contentStyle={{ padding: 0 }}
      >
        <div className={styles.caseTip}>
          <p>
            <img src="http://qnm.hunliji.com/o_1c03je7vj5jhplc13511ei9fnm7.png" />
            当前活动位您至多可提交{activity_position.max_set_meal_num}个套餐，同一个套餐只能报名一个活动位；报名后无法撤销，请谨慎提交
          </p>
        </div>
        <div className={styles.hideSelectAll}>
          <Table />
        </div>
        <div style={{ textAlign: 'center', marginTop: 50 }}>
          <Button style={{ marginRight: 30 }} onClick={store.goBack}>
            取消
          </Button>
          <Button type="primary" onClick={store.submitCase}>
            提交
          </Button>
        </div>
      </HeaderView>
    )
  }
}
